import { render, staticRenderFns } from "./BuscaSimples.vue?vue&type=template&id=415e526b&scoped=true"
import script from "./BuscaSimples.vue?vue&type=script&lang=js"
export * from "./BuscaSimples.vue?vue&type=script&lang=js"
import style0 from "./BuscaSimples.vue?vue&type=style&index=0&id=415e526b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415e526b",
  null
  
)

export default component.exports